import {Spinner} from './Spinner'
import { ResponsiveScreen } from '../../components/screen/ResponsiveScreen'
import { Navbar } from '../../components/navbar/Navbar'
import { GAME_MODE_LOADING } from '../../constants/strings'
import { getStoredDarkMode } from '../../lib/localStorage'
import { anonUserFactory } from '../../lib/user'

export const LoadingScreen = () => {
  const isDarkMode = getStoredDarkMode()
  if (isDarkMode) {
    document.documentElement.classList.add('dark')
  } else {
    document.documentElement.classList.remove('dark')
  }
  return <ResponsiveScreen responsive={true} id="app" className="flex flex-col">
    <Navbar
      user={anonUserFactory()}
      setIsInfoModalOpen={() =>{}}
      setIsStatsModalOpen={() => {}}
      setIsSettingsModalOpen={() => {}}
      setIsSupportModalOpen={() => {}}
      setIsProfileModalOpen={() => {}}
      onRefresh={() => {}}
      onGiveUp={() => {}}
      gameMode={GAME_MODE_LOADING}
      gameStatus={null}
    />
    <div className="flex items-center justify-center p-24">
      <Spinner key="1" />
    </div>
  </ResponsiveScreen>
}
